
<template>
    <div class="language-toggle">
      <button
        @click="toggleLanguage"
        :class="{ active: isEnglish }"
        class="toggle-btn"
        aria-label="Toggle language"
      >
        <span class="lang-option" :class="{ active: !isEnglish }">中文</span>
        <span class="lang-option" :class="{ active: isEnglish }">English</span>
        <span class="slider" :class="{ english: isEnglish }"></span>
      </button>
    </div>
  </template>
  
  <script>
  export default {
  data() {
      return {
        isEnglish: false
      };
    },
    methods: {
      toggleLanguage() {
        this.isEnglish = !this.isEnglish;
        this.$emit('updateLanguage', this.isEnglish)
      }
    }
  }
  </script>
  
  <style scoped>
  .language-toggle {
    display: inline-block;
    margin: 10px;
    background: #f0f0f0;
    z-index: 12;
    border-radius: 8px;
  }
  
  .toggle-btn {
    position: relative;
    width: 120px;
    height: 36px;
    border-radius: 8px;
    background: #f0f0f0;
    border: none;
    cursor: pointer;
    padding: 0;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }
  
  .toggle-btn:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  
  .lang-option {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    font-weight: 500;
    color: #888;
    transition: all 0.3s ease;
    z-index: 1;
  }
  
  .lang-option:first-child {
    left: 12px;
  }
  
  .lang-option:last-child {
    right: 12px;
  }
  
  .lang-option.active {
    color: #fff;
  }
  
  .slider {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 50px;
    height: 32px;
    background: #57bbff;
    border-radius: 8px;
    transition: all 0.3s ease;
    z-index: 0;
  }
  
  .slider.english {
    left: calc(100% - 70px);
    width: 68px;
    background: #57bbff;
  }
  </style>
  